module.exports = __webpack_public_path__ + "img/Type_Poison.8637f900.png";